import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import styles from './BecomeATutorHero.module.scss'
import Image from 'next/image'
import backgroundImage from '../public/images/become-tutor-bg.jpg'
import AuthRegistrationForm from './auth/RegistrationForm'
import jsonApiClient from '../utils/jsonApiClient'
import {signIn} from '../utils/auth'
import {appUrl} from '../utils/urlHelpers'

export default function BecomeATutorHero() {
  const submitForm = async (attrs) => {
    const jsonApi = jsonApiClient()

    // @Note: No try/catch here as RegistrationForm applies errors to the form
    await jsonApi.create('user', {
      ...attrs,
      roleName: 'tutor'
    }, {
      include: 'profile'
    })

    try {
      const { email, password } = attrs
      await signIn({email, password})

      window.location.replace(appUrl('account/dashboard'))
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className={styles.heroContainer}>
      <div className={styles.overlay}></div>

      <Image
        src={backgroundImage}
        className={styles.backgroundImage}
        alt="Cover photo"
        priority
        fill
        sizes="100vw"
        style={{
          objectFit: "cover",
          objectPosition: "center"
        }} />


      <Container className={`${styles.content} pt-lg-4 pb-4`}>
        <Row className="mt-md-5">
          <Col>
            <h1 className="loud-header text-white">
              Begin Tutoring Today
            </h1>

            <Row>
              <Col xs={12} md={8}>
                <div className="text-white mt-md-5">
                  <p className="font-weight-bold">
                    Join our community of tutors. Run your tutoring business on Tutorspot or simply tutor a few students
                    part-time.
                    You choose!
                  </p>

                  <p>
                    We help both new and experienced tutors find students, manage schedules and collect payments.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>

          <Col xs={12} md={4}>
            <Card className="mb-md-5">
              <Card.Body>
                <AuthRegistrationForm onSubmit={submitForm} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
